// @flow
import OneEmployee from './OneEmployee';
import { GENERAL_SECTION, EVENTS_SECTION, SETTINGS_SECTION } from './sections';
import allowedSections from './allowedSections';

export default OneEmployee;
export { GENERAL_SECTION, EVENTS_SECTION, SETTINGS_SECTION, allowedSections };
